import { useNavigate } from "react-router-dom";
import "../assets/css/notFound.css";

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-container">
      <div className="logo_container">
          <div className="logo_img"></div>
          <div className="logo_wrt"></div>
        </div>
        <div className="notfound-content">
          <h2>404</h2>
          <h3>Pagina Non Trovata</h3>
          <p>La pagina che stai cercando potrebbe essere stata rimossa, rinominata o non è mai esistita.</p>
          <button onClick={() => navigate("/")}>Torna alla Home</button>
        </div>
      </div>
    </div>
  );
}

export default NotFound;